import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { motion, AnimatePresence } from "framer-motion";
import { FAQS } from "../../data";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-cream py-20 sm:py-28">
      <div className="mx-auto max-w-3xl px-5">
        <Reveal>
          <Eyebrow>Good to know</Eyebrow>
          <h2 className="mt-4 font-display text-3xl leading-tight sm:text-5xl">Frequently asked</h2>
        </Reveal>

        <div className="mt-10 border-t border-ink" data-testid="faq-list">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-ink/20">
                <button
                  data-testid={`faq-question-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 py-5 text-left"
                >
                  <span className="font-display text-lg leading-snug sm:text-xl">{f.q}</span>
                  {isOpen ? <Minus size={22} className="shrink-0" /> : <Plus size={22} className="shrink-0" />}
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="overflow-hidden"
                    >
                      <p className="pb-5 pr-8 text-ink/70">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
